import React from 'react';

import uniexpo from "../../../../src/assets/img/uniexpo.webp";
import kbrtec from "../../../../src/assets/img/kbrtec.webp";
import teenager from "../../../../src/assets/img/teenager.webp";

import { DetailFooter } from '../../../assets/img/svg/details';
import { Facebook, Instagram, Linkedin, SimpleArrow, Mail, Whatsapp } from '../../../assets/img/svg/icons';

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    const Title: React.FC<{ title: string }> = ({ title }) => {
        return <h2 className="border-l-4 border-main-pink pl-4 font-semibold text-lg leading-5 inline-block">{title}</h2>;
    };

    const NavLink: React.FC<{ to: string, label: string }> = ({ to, label }) => {
        return (
            <a href={to} className="group inline-flex items-center gap-4 text-sm font-semibold transition-all duration-200 hover:text-main-pink -translate-x-2.5 sm:translate-x-0">
                <SimpleArrow className="opacity-20 transition-all duration-200 group-hover:fill-main-pink group-hover:opacity-100" />
                {label}
            </a>
        );
    };

    return (
        <footer className='bg-gradient-to-b from-light-blue to-white pt-8 xl:px-8'>
            <div className="xl:max-w-screen-lg 2xl:max-w-screen-xl mx-auto px-4 grid sm:grid-cols-2 lg:grid-cols-4 gap-4 text-center sm:text-left">
                <div className="pb-4 w-full lg:w-auto">
                    <div className="flex gap-6 items-center justify-center md:justify-start">
                        <a href="/" title='Uniexpo' className="inline-block">
                            <img src={uniexpo} alt="Uniexpo Logo" className='object-contain w-28 h-auto' />
                        </a>

                        <a href="https://teenager.com.br/" target='_blank' title='Teenager' className="inline-block">
                            <img src={teenager} alt="Teenager" className='object-contain w-28 h-auto' />
                        </a>
                    </div>

                    <p className='mt-4 sm:max-w-72 text-balance'>
                        A Uniexpo é uma iniciativa da Teenager. <br />
                        Há mais de 25 anos conectando jovens ao futuro acadêmico e profissional.
                    </p>

                    <div className="flex items-center gap-2 shrink-0 order-1 lg:order-none mt-8 z-20 justify-center sm:justify-normal">
                        <a href="https://www.facebook.com/uniexpooficial/" target="_blank" className="bg-main-yellow rounded-full h-8 w-8 inline-flex items-center justify-center transition-all duration-200 hover:bg-[#3b5998]" title="Facebook">
                            <Facebook className="h-1/2 object-contain w-1/2" />
                        </a>

                        <a href="https://www.instagram.com/uniexpo_oficial/" target="_blank" className="overflow-hidden relative bg-main-yellow rounded-full h-8 w-8 inline-flex items-center justify-center transition-all duration-200 before:content-[''] before:absolute before:inset-0 before:bg-[radial-gradient(circle_at_33%_100%,_#fed373_4%,_#f15245_30%,_#d92e7f_62%,_#9b36b7_85%,_#515ecf)] before:-z-10 before:opacity-0 before:transition-all before:duration-300 hover:before:opacity-100 hover:bg- z-20" title="Instagram">
                            <Instagram className="h-1/2 object-contain w-1/2" />
                        </a>

                        <a href="https://br.linkedin.com/company/teenagerassessoria" target="_blank" className="bg-main-yellow rounded-full h-8 w-8 inline-flex items-center justify-center transition-all duration-200 hover:bg-[#0077b5]" title="Linkedin">
                            <Linkedin className="h-1/2 object-contain w-1/2" />
                        </a>
                    </div>
                </div>

                <div className='justify-self-center w-full lg:w-auto'>
                    <Title title="Acesso rápido" />

                    <div className="flex flex-col items-center sm:items-start gap-4 mt-10">
                        <NavLink to="/agenda-de-eventos" label="Agenda de Eventos" />
                        <NavLink to="/quem-somos" label="Quem Somos" />
                        <NavLink to="/seja-um-expositor" label="Seja um Expositor" />
                        <NavLink to="/uniexpo-no-seu-colegio" label="Uniexpo no seu Colégio" />
                        <NavLink to="/blog" label="Blog" />
                        <NavLink to="/contatos" label="Contatos" />
                    </div>
                </div>

                <div className="grid sm:grid-cols-2 gap-4 sm:col-span-2 justify-self-center w-full mt-8 sm:mt-0">
                    <div className='justify-self-center w-full lg:w-auto'>
                        <Title title="Fale conosco" />
                        
                        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center sm:justify-normal gap-x-4 border-b border-black/10 pb-4 sm:pb-10 mb-4 sm:mb-8">
                            <Whatsapp className='h-10 w-10 object-contain' />

                            <div className="flex flex-col font-semibold">
                                Whatsapp
                                <a href="https://api.whatsapp.com/send?phone=5511971823024" target='_blank' title='Whatsapp' className='text-sm text-main-blue font-normal transition-all duration-200 hover:text-main-pink'>
                                    (11) 97182-3024
                                </a>
                            </div>
                        </div>

                        <NavLink to="/politica-de-privacidade" label="Politica de Privacidade" />
                    </div>

                    <div className='justify-self-center pt-5 w-full lg:w-auto'>
                        <div className="sm:mt-10 flex flex-col sm:flex-row items-center justify-center sm:justify-normal gap-x-4 border-b border-black/10 pb-4 sm:pb-10 mb-4 sm:mb-8">
                            <Mail className='h-10 w-10 object-contain' />

                            <div className="flex flex-col font-semibold">
                                E-mail
                                <a href="mailto:info@teenager.com.br" title='Telefone' className='text-sm text-main-blue font-normal transition-all duration-200 hover:text-main-pink'>
                                    info@teenager.com.br
                                </a>
                            </div>
                        </div>

                        <NavLink to="/termos-de-uso" label="Termos de Uso" />
                    </div>
                </div>
            </div>

            <div className="bg-main-blue/20 lg:bg-transparent px-4 max-w-screen-2xl mx-auto relative lg:h-36 flex items-end z-10 mt-10 lg:mt-0">
                <DetailFooter className='w-full h-full absolute -z-20 hidden lg:block' />

                <div className="max-w-[950px] xl:max-w-screen-lg 2xl:max-w-screen-xl mx-auto flex flex-col md:flex-row text-center items-center md:text-left justify-between font-anek text-sm w-full py-8 lg:py-0 lg:pb-8 gap-4">
                    <p>© {currentYear} Todos os direitos reservados para Uniexpo</p>

                    <div className="flex items-center gap-4">
                        Desenvolvido por

                        <a href="https://www.kbrtec.com.br/" target='_blank' title="KBR TEC" className='inline-block'>
                            <img src={kbrtec} alt="KBR TEC Logo" className='w-full h-auto' />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
